export class SubArea {
    Id: number;
    Name: string;

    AreaId: number;
    IsActive: boolean;
}
